// External Dependencies
import axios from 'axios';
import { toast } from 'react-toastify';

// Internal Dependencies
import { axiosConfig, ThrowErrorMsg } from '../util';
import { ADD_MALL_MAP, UPDATE_MALL_MAP } from '../types';
import { toastConfig } from '../../common/config';
import { deleteRequest, getRequest, postRequest, putRequest } from '../../services.js/apiService';

const STAFF_API_URL = `${process.env.REACT_APP_API_URL}/staff`;

export const addMallMap = (data) => async (dispatch) => {
  try {
    const mallMap = await postRequest(`${STAFF_API_URL}/mallMap`, data);
    dispatch({ type: ADD_MALL_MAP, payload: mallMap });
    toast.success('Map created.', toastConfig);
    return mallMap;
  } catch (err) {
    toast.error((err.response !== undefined) ? err.response.data : err.message);
    throw err;
  }
};

export const getMapsByParams = (params) => async () => getRequest(`${STAFF_API_URL}/mallMaps`, params);

export const getMallMapsByPageId = (params) => async () => getRequest(`${STAFF_API_URL}/mallMapsByPageId`, params);

export const updateMallMap = (id, data) => async (dispatch) => {
  try {
    const updated = await putRequest(`${STAFF_API_URL}/mallMap/${id}`, data);
    dispatch({ type: UPDATE_MALL_MAP, payload: updated });

    return updated;
  } catch (err) {
    toast.error((err.response !== undefined) ? err.response.data : err.message);
    ThrowErrorMsg(err);
  }
};

export const deleteMallMap = (id) => async () => {
  try {
    const result = await deleteRequest(`${STAFF_API_URL}/mallMap/${id}`);
    return result;
  } catch (err) {
    toast.error((err.response !== undefined) ? err.response.data : err.message);
    throw err;
  }
};
